export default import.meta.ROLLDOWN_FILE_URL_8znKsWwvpU$pVGiZRms5Cg